import { render, staticRenderFns } from "./SendButton.vue?vue&type=template&id=71875f49"
import script from "./SendButton.vue?vue&type=script&lang=js"
export * from "./SendButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports